export { getMinMaxDate } from "app/common/benchmark/dateRange";

export enum AutomationTagGeneratorBase {
    Benchmark = "benchmark-tracker",
    Activation = "Activation",
}

type AutomationTagPlaces = "home" | "report" | "root" | "builder" | string; //FIXME

// Generates value for data-automation tag to make more similar values
export const generateAutomationName = (
    place: AutomationTagPlaces,
    names: string[],
    base: AutomationTagGeneratorBase = AutomationTagGeneratorBase.Benchmark,
) => {
    let _base = `${base}-${place}`;

    for (let index = 0; index < names.length; index++) {
        _base = _base.concat(`-${names[index]}`);
    }

    return _base;
};
